import Repository from "./repository";

const storage = process.env.VUE_APP_STORAGE_URL;

export default {
  theme() {
    // customize
    return Repository.get(
      `${storage}common/lang/customize/tarobou-en/theme.json`
    );
  },

  public() {
    // customize
    return Repository.get(
      `${storage}common/lang/customize/tarobou-en/public.json`
    );
  },
};
